import React from "react"
import Tabs from "../Tabs/Tabs";
import clsx from "clsx";
import RichTextEditor from "../RichTextEditor/RichTextEditor"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import MessageBuilderImageGroup from "../MessageBuilder/MessageBuilderImageGroup"

export default class SendMessage extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      editor_active_tab: 'editor',
      error: null,
      success: null,
      loading: false,
      read_only:
        typeof this.props.read_only != "undefined"
          ? this.props.read_only
          : false,
      from: this.props.message && this.props.message.from ? this.props.message.from : '',
      to: this.props.message && this.props.message.to ? this.props.message.to : '',
      body: this.props.message && this.props.message.body ? this.props.message.body : '',
      image_group: this.props.image_group ? this.props.image_group : null,
      image_group_ids: this.props.image_group && this.props.image_group.images ? this.props.image_group.images.map((image) => image.id) : null
    };

    this.onChange = this.onChange.bind(this)
    this.onChangeBody = this.onChangeBody.bind(this)
    this.sendMessage = this.sendMessage.bind(this)
    this.onChangeImages = this.onChangeImages.bind(this);
    this.setActiveTab = this.setActiveTab.bind(this);
  }

  render() {
    if (this.state.read_only == false) {
      var buttons = [
        {
          name: I18n.t('cancel'),
          html_attributes: ['data-dismiss="modal"']
        },
        {
          name: I18n.t('send_now'),
          button_classes: ['primary'],
          onClick: this.sendMessage,
        },
      ]
    } else {
      var buttons = [
        {
          name: I18n.t('ok'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },
      ]
    }

    var editorTabClasses = clsx({
      'active': this.state.editor_active_tab == 'editor',
      'tab-pane': true,
      'editorWrapper': true
    })

    return (
      <div className="resend-email">
        <Tabs tabs={this.tabs()}/>
        <LoadingSpinner show={this.state.loading} />
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        {this.state.error ? <div className="alert alert-danger">{this.state.error}</div> : null}
        {this.state.success ? <div className="alert-success">{this.state.success}</div> : null}

        <div className="tab-content">
          <div className={editorTabClasses}>
            <div className="to-cc-bcc-subject">
              <div className="row">
                <div className="col-sm-12">
                  <div className="input-group">
                    <div className="input-group-addon">{I18n.t('from')}</div>
                    <input type="text" name="message[from]" ref="from" data-name="from" className='form-control' defaultValue={this.state.from} onChange={this.onChange.bind(null, 'from')} disabled={this.state.read_only}/>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="input-group">
                    <div className="input-group-addon">{I18n.t('to')}</div>
                    <input type="text" name="message[to]" ref="to" data-name="to" className='form-control' defaultValue={this.state.to} onChange={this.onChange.bind(null, 'to')} disabled={this.state.read_only}/>
                  </div>
                </div>
              </div>
            </div>

            <div className="editor" ref="inner">
              <RichTextEditor body={this.state.body} onChange={this.onChangeBody} auto_resize={true} message={true}/>
            </div>
          </div>
          <MessageBuilderImageGroup {...this.props} {...this.state} onChangeImages={this.onChangeImages} images_data_table_path={this.props.images_data_table_path}></MessageBuilderImageGroup>
        </div>
      </div>
    );
  }

  tabs() {
    var tabs = [];

    tabs.push({
      tabName: I18n.t("editor"),
      targetName: "editor",
      classes: this.state.editor_active_tab === "editor" ? "active" : null,
      changeHandler: this.setActiveTab,
    });

    tabs.push({
      tabName: I18n.t("images"),
      targetName: "images",
      classes: this.state.editor_active_tab === "images" ? "active" : null,
      changeHandler: this.setActiveTab,
    });

    return tabs;
  }

  onChange(name, event) {
    var state = this.state;
    state[name] = event.target.value;
    this.setState(state);
  }

  onChangeBody(body) {
    this.setState({body: body});
  }
  
  onChangeImages(image_group) {
    var image_group_ids = image_group.images.map((image) => image.id);
    if (image_group) {
      this.setState({
        image_group_ids: image_group_ids,
        image_group: image_group,
      });
    } else {
      this.setState({
        image_group_ids: null,
        image_group: null,
      });
    }
  }

  setActiveTab(tab) {
    this.setState({
      editor_active_tab: tab,
    });
  }

  sendMessage() {
    var self = this;
    this.setState({loading: true})
    $.ajax({
      type: 'POST',
      url: this.props.path,
      data: {
        from: this.state.from,
        to: this.state.to,
        body: this.state.body,
        reservation_id: this.props.reservation_id,
        reservation_segment_id: this.props.reservation_segment_id,
        order_id: this.props.order_id,
        image_group: this.state.image_group,
        image_group_ids: this.state.image_group_ids,
        id: this.props.message_id
      },
    }).done((data) => {
      if (data.error) {
        self.setState({loading: false, error: data.error});
      } else if (data.success) {
        self.setState({success: data.success, loading: false}, () => {
          if (parent && parent.refresh_data) {
            parent.refresh_data(I18n.t('message_sent_successfully'));
          }
          window.handleAlertSuccess();
          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
        });
      }
    });
  }
};
